import { toDateTime } from 'utils/date';

const EDITED_AFTER_MS = 1000;

export const isCommentEdited = (
  comment: { createdAt?: Date | string; modifiedAt?: Date | string },
) => {
  const created = toDateTime(comment.createdAt);
  const modified = toDateTime(comment.modifiedAt);
  if (!created?.isValid || !modified?.isValid) {
    return false;
  }
  return modified.toMillis() - created.toMillis() > EDITED_AFTER_MS;
};
